import { PageInterface } from "@lg-cfa/types";
import { getPageByPath } from "@lg-cfa/utils";
import { useRecoilValue, useSetRecoilState } from "recoil";

import { PageNames } from "@enums";
import { isStateKeyEmpty } from "@helpers";
import { flowFinishedState, pagesState, userDataState } from "@states";
import { UserDataInterface } from "@types";

export function usePageDataValidator() {
    const allPages = useRecoilValue(pagesState);
    const userData = useRecoilValue(userDataState);
    const setFlowFinished = useSetRecoilState(flowFinishedState);

    const getPage = (path: string) => {
        const foundPage = getPageByPath(allPages, path);
        if (foundPage !== undefined) {
            return foundPage;
        } else {
            const pageByPath = getPageByPath(allPages, path);
            if (pageByPath !== undefined) {
                return pageByPath;
            }
        }
    };

    const matchUserWithPageData = (
        page: PageInterface | undefined,
        data: UserDataInterface,
    ) => {
        if (!page) return false;

        if (page.name !== PageNames.ThankYou) {
            setFlowFinished(false);
        }

        let dataToMatch = [...page.neededData];

        // 1. check if WTC, change dataToMatch if so
        if (data.weTakeCareActivated) {
            dataToMatch = [...page.weTakeCareData];
        }

        // 2. if no dataToMatch, we can be where we are so return true
        if (dataToMatch.length === 0) return true;

        let valid = true;
        // 3. if dataToMatch, check if we have the data required
        dataToMatch.forEach((key) => {
            if (isStateKeyEmpty(key, data)) valid = false;
        });

        return valid;
    };

    const isValidPath = (path: string) => {
        // 1. get current page
        const page = getPage(path);
        // 2. get current state data
        const data = userData;
        // 3. check if current state data matches with needed data of current page
        return matchUserWithPageData(page, data);
    };

    const isValidPage = (page: PageInterface) => {
        const data = userData;
        return matchUserWithPageData(page, data);
    };

    return { isValidPath, isValidPage };
}
